<template>
  <div class="">
    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>

    <div v-else>
      <div class="ui grid">
        <div class="left aligned five wide column">
          <!-- <div class="ui very compact left floated medium red button"
               style="background-color: #092442; margin-top: 8px"
               @click="archiveEmployee()"
               v-if="!employee.deleted_at && employee.user.id !== $auth.user().id">
            {{ $t('archive') }}
          </div>

          <div class="ui very compact left floated medium red button"
               style="background-color: #092442; margin-top: 8px"
               @click="restoreEmployee()"
               v-if="employee.deleted_at && employee.user.id !== $auth.user().id">
            {{ $t('restore') }}
          </div> -->
        </div>

        <div class="left aligned eleven wide column">
          <h1 class="ui center aligned icon header" style="color: #092442">
            {{$t('employee') }} {{ employee.user.name }}
          </h1>
        </div>

        <div class="left aligned column"></div>
      </div>


      <div class="ui divider" style="margin-top: -40px"></div>

      <div class="ui grid container" style="padding-top: 15px">
        <!-- {{ employee }} -->
        <div class="four wide column">
          <div class="ui grid">
            <div class="row">
              <div class="column centered-header">
                <imageComponent :object="employee"
                                :sendingURL="'employees/' + employee.id + '/add/image'"
                                :params="{clinic_id: getFromLocalStorage('clinicId')}">
                </imageComponent>
              </div>
            </div>
<!--             <div class="row">
              <div class="column">

                <div class="ui grid">
                  <div class="row">
                    <div class="column">
                      <input type="file" id="attachment" style="display:none;" @change="onFileChangeForCreate">
                      <label for="attachment" class="ui left floated fluid button">
                        <i class="ui upload icon"></i>
                        {{ $t('uploadCV') }}
                      </label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="column"  style="margin-top: -20px">
                      <label for="" v-if="currentFile">
                        <strong>{{ currentFile }}</strong>
                        <a style="cursor: pointer;margin-left: 10px;" @click="saveResume()">
                          {{ $t('upload') }}
                        </a>
                      </label>
                    </div>
                  </div>
                </div>

              </div>
            </div> -->
          </div>

        </div>
        <div class="twelve wide column" >
          <h4 class="ui dividing header">
            {{ $t('personalInfo') }}
          </h4>
          <abstractTable :data="employeeInfo"
                         :definitionTable="true"
                         :definitionTableWidth="'16%'"
                         :classes="'ui compact definition table'">
          </abstractTable>

          <h4 class="ui dividing header">
            {{ $t('contactInfo') }}
          </h4>
          <abstractTable :data="contactInfo"
                         :definitionTable="true"
                         :definitionTableWidth="'16%'"
                         :classes="'ui compact definition table'">
          </abstractTable>

          <h4 class="ui dividing header">
            {{ $t('jobInfo') }}
          </h4>
          <abstractTable :data="jobInfo"
                         :definitionTable="true"
                         :definitionTableWidth="'16%'"
                         :classes="'ui compact definition table'">
          </abstractTable>
        </div>
      </div>

      <br/>
      <div class="ui horizontal divider">{{ $t('otherInfo') }}</div>

      <div class="ui tabular menu">
        <a class="item" :class="{ active: currentTab === tabs.first }"
           @click="currentTab = tabs.first">
          {{ $t('reservations') }}
        </a>

        <a class="item" :class="{ active: currentTab === tabs.second }"
           @click="currentTab = tabs.second">
          {{ $t('payslips') }}
        </a>
      </div>

      <div v-if="currentTab === tabs.first" style="margin-top: 10px">
        <reservationsPart :employee="employee" :doctors="doctors" :patients="patients">
        </reservationsPart>
      </div>

      <div v-if="currentTab === tabs.second" style="margin-top: 10px">
        <payslipsPart :employee="employee">
        </payslipsPart>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    imageComponent: require('@/components/abstract_components/Image').default,
    payslipsPart: require('@/components/employees/employee_components/PayslipsPart').default,
    reservationsPart: require('@/components/employees/employee_components/ReservationsPart').default,
    filesPart: require('@/components/employees/employee_components/FilesPart').default
  },
  data () {
    return {
      employee: {},
      loading: true,
      tabs: {
        first: 'reservations',
        second: 'payslips',
        third: 'cv'
      },
      currentTab: 'reservations',
      currentFile: null,
      resume: {
        name: null,
        attachment: null
      },
      doctors: [],
      patients: []
    }
  },
  beforeMount () {
    this.getEmployee()
  },
  watch: {
    employee: {
      handler: function () {
        if (this.employee.user.id === this.$auth.user().id) {
          if (this.$auth.user().images.length < this.employee.album.images.length) {
            this.$auth.user().images = this.employee.album.images
          } else {
            this.employee.album.images = this.$auth.user().images
          }
        }
      },
      deep: true
    }
  },
  computed: {
    employeeInfo () {
      return {
        [this.$t('nationalId')]: this.employee.national_id,
        [this.$t('age')]: this.getAge(this.employee.user.date_of_birth),
        [this.$t('gender')]: this.getGender(this.employee.user.gender),
        [this.$t('maritalStatus')]: this.getMaritalStatus(this.employee.marital_status),
        [this.$t('address')]: this.employee.user.address
      }
    },
    contactInfo () {
      return {
        [this.$t('email')]: this.employee.user.email,
        [this.$t('phone')]: this.employee.user.home_phone,
        [this.$t('mobile')]: this.employee.user.mobile
      }
    },
    jobInfo () {
      return {
        [this.$t('jobTitle')]: this.employee.job_title,
        [this.$t('hireDate')]: window.moment(this.employee.hire_date).format('LLLL'),
        [this.$t('salary')]: '£' + this.employee.salary_amount,
        [this.$t('workStatus')]: this.employee.deleted_at
          ? this.$t('archived') : this.$t('heIsStillWorking')
      }
    }
  },
  methods: {
    getEmployee () {
      this.$http.get(`employees/${this.$route.params.id}`, {
        params: {
          clinic_id: this.getFromLocalStorage('clinicId')
        }
      }).then(response => {
        this.employee = response.data.employee
        this.doctors = response.data.meta.doctors
        this.patients = response.data.meta.patients
        this.employee.reservations = response.data.meta.reservations
        this.loading = false
      })
    },
    archiveEmployee () {
      this.$swal({
        title: `${this.$t('youAreGoingToArchive')} ${this.employee.user.name}`,
        type: 'warning',
        confirmButtonText: `${this.$t('yes,Archive')}`,
        confirmButtonColor: '#092442',
        preConfirm: () => {
          return this.$http.post(`users/${this.employee.user.id}/archive`, {
            clinic_id: this.getFromLocalStorage('clinicId')
          }).then(() => {
            this.getEmployee()
          })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.$swal({
            title: `${this.$t('archived')}!`,
            type: 'success'
          })
        }
      })
    },
    restoreEmployee () {
      this.$swal({
        title: `${this.$t('youAreGoingToRestore')} ${this.employee.user.name}`,
        type: 'warning',
        confirmButtonText: `${this.$t('yes,Restore')}`,
        confirmButtonColor: '#092442',
        preConfirm: () => {
          return this.$http.post(`users/${this.employee.user.id}/restore`, {
            clinic_id: this.getFromLocalStorage('clinicId')
          }).then(() => {
            this.getEmployee()
          })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.$swal({
            title: `${this.$t('restored')}!`,
            type: 'success'
          })
        }
      })
    },
    onFileChangeForCreate (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.createFile(files[0])
    },
    createFile (file) {
      var reader = new FileReader()
      this.currentFile = file.name
      reader.onload = (e) => {
        this.resume.name = this.employee.user.name + ' Resume'
        this.resume.attachment = e.target.result
      }
      reader.readAsDataURL(file)
    },
    saveResume () {
      this.$http.post(`employees/${this.employee.id}/add/resume`, {
        clinic_id: this.getFromLocalStorage('clinicId'),
        resume: this.resume
      }).then(response => {
        this.currentFile = null
        this.resume = {
          name: null,
          attachment: null
        }
        this.getEmployee()
      })
    }
  }
}
</script>

<style scoped>
.price-popup {
  cursor: pointer;
  color: #2185d0 !important;
}
.centered-header {
  display: flex !important;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/employees/Employee.vue